import { Component, OnInit } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {MatSnackBar as MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AuthService } from "src/app/services/auth.service";
import { ToastrService } from "ngx-toastr";
import { SiteService } from "src/app/sites-management/site.service";
import { CookieService } from 'ngx-cookie';
import { ETemplateTypes } from "src/app/models/general-enums";

@Component({
  selector: "app-templates",
  templateUrl: "./page-templates.component.html",
  styleUrls: ["./page-templates.component.css"],
})

export class PageTemplatesComponent implements OnInit {
  viewTemplateSetting: boolean = false;
  template: any;
  enumArrType;
  searchText = "";
  allTemplates: any[] = [];
  showarchivedTemplate: boolean = false;
  archivedTemplates: any[] = [];
  isEditPage: boolean = false;
  constructor(
    private authService: AuthService,
    private httpClient: HttpClient,
     private snotifyService: ToastrService,
    private _snackBar: MatSnackBar,
    private siteService: SiteService,
    private routing: Router,
    private cookieService: CookieService,

  ) {
    
  }

  ngOnInit() {
       this.user = this.authService.getLoggedUser()

    this.GetAllTemplates();
    this.siteService.isSiteChanged$.subscribe(res => console.log('res', res))
  }

  back() {
    window.history.back();
  }

  GetAllTemplates() {
    this.allTemplates = [];
    this.archivedTemplates = [];
    this.httpClient
      .get("/PageTemplate/GetAllPageTemplates")
      .subscribe((res: any) => {
        if (res && res.length > 0) {
          this.getETemplateTypes();
          res.forEach((element) => {
            // unpublish = 1
            // publish   = 2
            for (let type of this.enumArrType) {
              if (type.value == element.type) {
                type.childTemplates.push(element);
              }
            }
            if (element.status == 2)
              this.allTemplates.push(element);
            if (element.status == 1)
              this.archivedTemplates.push(element);
            console.log('archived', this.archivedTemplates);
          });
        }
      });
  }


  getETemplateTypes() {
    this.enumArrType = [];
    for (let item in ETemplateTypes) {
      if (isNaN(Number(item))) {
        this.enumArrType.push({ name: item, value: ETemplateTypes[item], childTemplates: [] });
      }
    }
  }
  deleteArchiveTemplate(archive) {
    const data = {
      Name: archive.name,
      Description: archive.description,
      Type: archive.type,
      AddtionalMetaTags: archive.addtionalMetaTags
        ? JSON.stringify(archive.addtionalMetaTags)
        : null,
      Status: 4,
    };

    this.httpClient
      .post("/PageTemplate/EditPageTemplates/" + archive.id, data)
      .subscribe((res: any) => {
        this.GetAllTemplates();
        this.showarchivedTemplate = true;
      });
  }

  add() {
    this.template = {};
    this.template.name = "";
    this.viewTemplateSetting = true;
  }

  edit(p) {
    this.template = JSON.parse(JSON.stringify(p));
    this.viewTemplateSetting = true;
  }

  duplicat(p) {
    this.template = JSON.parse(JSON.stringify(p));
    this.template.duplicatingId = this.template.id;
    this.template.id = null;

    this.viewTemplateSetting = true;
  }

  RouteToTempbuilder(id) {
    if (this.authService.checkRole("COBT")) {
      this.routing.navigate(["templates-builder", id]);
    }
  }

  checkTemplateResult($event) {
    if ($event && $event !== 0) {
      this.openNotifySuccess("Saved");
      this.GetAllTemplates();
      this.template = {};
    }
    this.viewTemplateSetting = false;
  }

  // openSnackBar(message: string) {
  //   this._snackBar.open(message, '', {
  //     duration: 2000,
  //   });
  // }
  openNotifySuccess(message: string) {
    this.snotifyService.success("", message, {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  openNotifyError(message: string) {
    this.snotifyService.error(message, "Something went wrong!!", {
     timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  delete(template) {
    this.httpClient
      .delete("/PageTemplate/DeleteTemplateByID/" + template.id)
      .subscribe((res: any) => {
        this.openNotifySuccess("Template " + template.name + " Deleted");
        this.GetAllTemplates();
      });
  }

  restoreTemplate(archive) {
    const data = {
      Name: archive.name,
      Description: archive.description,
      Type: archive.type,
      AddtionalMetaTags: archive.addtionalMetaTags
        ? JSON.stringify(archive.addtionalMetaTags)
        : null,
      Status: 2,
    };

    this.httpClient
      .post("/PageTemplate/EditPageTemplates/" + archive.id, data)
      .subscribe((res: any) => {
        this.GetAllTemplates();
        this.showarchivedTemplate = false;
      });
  }
  user: any;
  openBuilder(template, source?) {
    let code = ['COBT', 'CEPT', 'CESMT', 'CEBPT']
    if (this.user && this.user.RoleInfo) {

      for (let i = 0; i < this.user.RoleInfo.length; i++) {
        const role = this.user.RoleInfo[i];
        if (code.includes(role)) {
          if (!source)
            this.routing.navigate([`templates-builder/${template.id}`]);
          return true;
        }
      }
      return false;
    }

  }


}
